import { Link } from 'gatsby';
import React, { PropsWithChildren, ReactNode } from 'react';

import {
  Description,
  Title,
  TitleContainer,
  Wrapper,
} from './ProductCard.styled';
import { Button } from 'amphitheatre';
import { Stack } from 'src/page-styles/base.styled';

interface Props {
  name: ReactNode;
  icon: ReactNode;
  learnMoreHref: string;
}

/**
 * Displays a career position
 *
 * @param {string} name Name of the product
 * @param {ReactNode} icon StaticImage node to render as the icon
 * @param {string} learnMoreHref Link to the page that offers more detail about this product
 */
function ProductCard({
  name,
  icon,
  learnMoreHref,
  children,
}: PropsWithChildren<Props>): JSX.Element {
  return (
    <Wrapper data-cy="product-card-container">
      <TitleContainer>
        <Stack style={{ alignItems: 'center' }}>
          {icon}
          <Title>{name}</Title>
        </Stack>
      </TitleContainer>
      <Description>{children}</Description>
      <Link
        to={learnMoreHref}
        style={{ marginTop: 24, justifySelf: 'flex-end' }}
      >
        <Button ghost>Learn more</Button>
      </Link>
    </Wrapper>
  );
}

export default ProductCard;
